import React from 'react';
import { Alert, Button, Modal } from 'react-bootstrap';
import { FaInfoCircle, FaPhoneAlt, FaUserTimes, FaWhatsapp } from 'react-icons/fa';

export default function PatientRegistrationModal({ show, onHide, cpf }) {
  // Número da recepção/WhatsApp da Prevencor para direcionamento
  const WHATSAPP_NUMBER = '551434022700'; // Substitua pelo número real da clínica
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=Olá,%20gostaria%20de%20cadastrar%20meu%20CPF%20(${cpf})%20para%20realizar%20um%20agendamento%20online.`;

  return (
    <Modal show={show} onHide={onHide} centered size="md" backdrop="static">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="w-100 text-center">
          <div
            className="d-inline-flex align-items-center justify-content-center rounded-circle mb-2"
            style={{ width: '56px', height: '56px', backgroundColor: '#fff3cd', color: '#856404' }}
          >
            <FaUserTimes size={26} />
          </div>
          <h5 className="fw-bold text-dark mb-0">Cadastro Não Localizado</h5>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4 py-3 text-center">
        {/* Banner com a confirmação do CPF */}
        <Alert
          variant="warning"
          className="d-flex align-items-center justify-content-center gap-2 mb-3 border-0 text-start small"
          style={{ backgroundColor: '#fff8e6', color: '#664d03' }}
        >
          <FaInfoCircle size={18} className="flex-shrink-0" />
          <div>
            O CPF <strong>{cpf || 'informado'}</strong> é válido, mas ainda não possui cadastro
            ativo na <strong>Clínica Prevencor</strong>.
          </div>
        </Alert>

        <p className="text-muted small mb-4" style={{ lineHeight: '1.6' }}>
          Para sua segurança e organização da agenda, o agendamento online é exclusivo para
          pacientes com ficha cadastral. Entre em contato conosco para realizar seu primeiro
          cadastro:
        </p>

        {/* Opções de Atendimento para o Paciente */}
        <div className="d-flex flex-column gap-2 mb-2">
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-success fw-bold rounded-3 d-flex align-items-center justify-content-center gap-2 py-2"
          >
            <FaWhatsapp size={18} />
            <span>Cadastrar pelo WhatsApp</span>
          </a>

          <div className="text-muted extra-small my-1">— ou ligue para a recepção —</div>

          <div className="d-flex align-items-center justify-content-center gap-2 text-dark fw-semibold small p-2 bg-light rounded-3 border">
            <FaPhoneAlt className="text-primary" size={14} />
            <span>(14) 3402-2700</span>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="border-0 pt-0 px-4 pb-4">
        <Button variant="outline-secondary" onClick={onHide} className="w-100 rounded-3">
          Tentar outro CPF
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
